import LazyLoad from "vanilla-lazyload";
// import simplyCountdown
import "simplycountdown.js/dist/simplyCountdown.min.js";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import init from "./common";

init();
// Init Lazy load instance
var lazyLoad = new LazyLoad();
function sliderLazy() {
  lazyLoad.update();
}

// Récupérer l'élément countdown et ses données
const countdownElement = document.querySelector(".countdown");
if (countdownElement) {
  const dateStr = countdownElement.getAttribute("data-countdown");
  const [year, month, day, hours, minutes, seconds] = dateStr
    .split("-")
    .map(Number);

  simplyCountdown(".countdown", {
    year: year,
    month: month,
    day: day,
    hours: hours || 0,
    minutes: minutes || 0,
    seconds: seconds || 0,
    enableUtc: true, // Important pour la gestion des fuseaux horaires
    words: {
      days: { singular: "J", plural: "J" },
      hours: { singular: "H", plural: "H" },
      minutes: { singular: "Min", plural: "Mins" },
      seconds: { singular: "S", plural: "S" },
    },
    zeroPad: true, // Pour avoir des nombres à deux chiffres
  });
}

var swiper_pass = new Swiper(".swiper-match-a-venir", {
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  loop: true,
  slidesPerView: 1,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 2.5,
  },

  navigation: {
    nextEl: ".match-venir-button-next",
    prevEl: ".match-venir-button-prev",
  },

  breakpoints: {
    1280: {
      slidesPerView: 3,
    },
    900: {
      slidesPerView: 2,
    },
  },
});

var swiper_galerie = new Swiper(".swiper-galerie", {
  spaceBetween: 0,
  loop: true,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".galerie-button-next",
    prevEl: ".galerie-button-prev",
  },

  breakpoints: {
    1280: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 1,
    },
  },
});

var swiper_joueurs = new Swiper(".swiper-joueurs", {
  spaceBetween: 20,
  loop: true,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".joueurs-button-next",
    prevEl: ".joueurs-button-prev",
  },

  breakpoints: {
    1720: {
      slidesPerView: 5,
    },

    1024: {
      slidesPerView: 4,
    },
    768: {
      slidesPerView: 3,
    },
    640: {
      slidesPerView: 1,
    },
  },
});

var swiper_partenaires = new Swiper(".swiper-partenaires", {
  spaceBetween: 10,
  loop: true,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".partenaires-button-next",
    prevEl: ".partenaires-button-prev",
  },

  breakpoints: {
    1280: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 1,
    },
  },
});

console.log("home_js");
